import EventManager, { preventDefault, stopEvent, stopPropagation } from '../../../es/_util/EventManager';
export default EventManager;
export { preventDefault, stopPropagation, stopEvent, };
